
export default class LateReportTypes {
    public static readonly CommitteeFiling: string = '1';
    public static readonly VSR: string = '2';
}
